module.exports = __webpack_public_path__ + "static/media/17UN-Women8.f9b27472.jpg";